import { useState } from "react";
import { useLocation } from "react-router-dom";
import { HelpCircle, X } from "lucide-react";

const HELP = {
  dashboard: { t: "Overview", b: ["See your RSVP counts at a glance.", "Use \u201CPreview my event page\u201D to see what guests will see.", "Publish by unlocking the Guest List & Invitations bundle in Unlock Features."] },
  guests: { t: "Guests", b: ["Add guests for free; link plus-ones to an email holder.", "Add from your saved favourite contacts to go faster.", "Print or export your list to .xlsx."] },
  invitation: { t: "Invitation", b: ["Write your title & message and add a header photo.", "Choose which RSVP questions to ask.", "Print a QR code for guests without email."] },
  tasks: { t: "Checklist", b: ["Tick off planning tasks tailored to your event."] },
  vendors: { t: "Vendors", b: ["Store contracts and set payment plans that total the quote.", "Paid amounts flow into your Budget automatically."] },
  budget: { t: "Budget", b: ["Set estimates; paid amounts come from vendor installments."] },
  seating: { t: "Seating", b: ["Drag tables, resize from the corner, click to seat guests.", "Auto-number your tables, then print the floor plan."] },
  gallery: { t: "Gallery", b: ["Approve guest photos before they appear.", "Click any photo to enlarge it."] },
  thankyou: { t: "Thank You", b: ["Draft, preview and send thank-you emails.", "Track gifts and who has been thanked."] },
  setup: { t: "Event", b: ["Edit details, cover photo and theme.", "Add co-hosts and make your page private."] },
  pricing: { t: "Unlock Features", b: ["Unlock features per event, or Unlock Everything.", "Registry and your guest list are always free."] },
  messages: { t: "Messages", b: ["See every email sent to your guests."] },
};

export function HelpFab() {
  const [open, setOpen] = useState(false);
  const seg = (useLocation().pathname.split("/e/")[1] || "").split("/")[1] || "dashboard";
  const h = HELP[seg] || HELP.dashboard;
  return (
    <>
      <button onClick={() => setOpen(!open)} data-testid="help-fab" title="Help for this page"
        className="fixed bottom-6 right-6 z-40 w-12 h-12 rounded-full bg-[#2C2A28] text-white grid place-items-center shadow-lg hover:bg-[#8C9A86] transition-colors">
        <HelpCircle size={22} />
      </button>
      {open && (
        <div className="fixed bottom-20 right-6 z-40 w-72 bg-white border border-[#E8E6E1] rounded-xl shadow-xl p-5 fade-up" data-testid="help-popover">
          <div className="flex items-center justify-between mb-2"><p className="font-serif text-xl">{h.t}</p><button onClick={() => setOpen(false)} className="text-stone-400 hover:text-stone-700"><X size={16} /></button></div>
          <ul className="space-y-2 text-sm text-stone-600 list-disc pl-4">{h.b.map((x, i) => <li key={i}>{x}</li>)}</ul>
        </div>
      )}
    </>
  );
}
